import React from 'react';

import { Container } from './styles';

const Paginator: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Paginator;
